import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { APP_ROUTE_SEGMENTS } from './core/constants/app-routes';
import { HomeComponent } from './pages/home-components/home/home.component';
import { ListeBiensComponent } from './pages/logements/liste-biens/liste-biens.component';
import { AjoutBienComponent } from './pages/logements/ajout-bien/ajout-bien.component';
import { FicheBienComponent } from './pages/logements/fiche-bien/fiche-bien.component';
import { DossierTechniqueComponent } from './pages/logements/dossier-technique/dossier-technique.component';
import { AjoutContactComponent } from './pages/contacts/ajout-contact/ajout-contact.component';
import { FicheContactComponent } from './pages/contacts/fiche-contact/fiche-contact.component';
import { ListeContactsComponent } from './pages/contacts/liste-contacts/liste-contacts.component';
import { AjoutLocataireComponent } from './pages/locataires/ajout-locataire/ajout-locataire.component';
import { FicheLocataireComponent } from './pages/locataires/fiche-locataire/fiche-locataire.component';
import { ListeLocatairesComponent } from './pages/locataires/liste-locataires/liste-locataires.component';

export const routes: Routes = [
  { path: '', redirectTo: APP_ROUTE_SEGMENTS.accueil, pathMatch: 'full' },
  {
    path: APP_ROUTE_SEGMENTS.accueil,
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: APP_ROUTE_SEGMENTS.logements,
    component: ListeBiensComponent,
    canActivate: [authGuard],
  },
  {
    path: APP_ROUTE_SEGMENTS.ajoutLogements,
    component: AjoutBienComponent,
    canActivate: [authGuard],
  },
  {
    path: `${APP_ROUTE_SEGMENTS.logements}/:bienId/${APP_ROUTE_SEGMENTS.unites}/:logementId/${APP_ROUTE_SEGMENTS.dossierTechnique}`,
    component: DossierTechniqueComponent,
    canActivate: [authGuard],
  },
  {
    path: `${APP_ROUTE_SEGMENTS.logements}/:id`,
    component: FicheBienComponent,
    canActivate: [authGuard],
  },
  {
    path: APP_ROUTE_SEGMENTS.contacts,
    component: ListeContactsComponent,
    canActivate: [authGuard],
  },
  {
    path: APP_ROUTE_SEGMENTS.ajoutContacts,
    component: AjoutContactComponent,
    canActivate: [authGuard],
  },
  {
    path: `${APP_ROUTE_SEGMENTS.contacts}/:id`,
    component: FicheContactComponent,
    canActivate: [authGuard],
  },
  {
    path: APP_ROUTE_SEGMENTS.locataires,
    component: ListeLocatairesComponent,
    canActivate: [authGuard],
  },
  {
    path: APP_ROUTE_SEGMENTS.ajoutLocataires,
    component: AjoutLocataireComponent,
    canActivate: [authGuard],
  },
  {
    path: `${APP_ROUTE_SEGMENTS.locataires}/:id`,
    component: FicheLocataireComponent,
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: APP_ROUTE_SEGMENTS.accueil },
];
